import { useState, useRef, useEffect } from "react";
import { Link } from "@inertiajs/react";
import { motion, AnimatePresence } from "framer-motion";
import NavButton from "@/Components/Global/NavButton";
import { HamburgerItem } from "./Hamburger";

const MobileGuestHeader = () => {
    const [isOpen, setOpen] = useState(false);
    const toggleDropDown = () => {
        setOpen(!isOpen);
    };
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

    return (
        <div
            ref={ref}
            className="lg:hidden sticky top-0 z-50 bg-white dark:bg-secondary-dark"
        >
            <div className="max-w-[1440px] m-auto flex justify-between items-center h-[60px] px-[4vw]  md:px-6 2xl:px-0">
                <HamburgerItem
                    showingNavigationDropdown={isOpen}
                    toggleDropDown={toggleDropDown}
                    size={50}
                />

                <div className="flex gap-[10px]">
                    <div className="mt-4 text-center">
                        <Link
                            href="/login"
                            className="mr-1 text-sm font-semibold text-black dark:text-text-dark"
                        >
                            login
                        </Link>
                    </div>
                    <div className="h-[52px]">
                        <img
                            src="/assets/images/icons/profileLight.svg"
                            alt="User Avatar"
                            className="h-full mt-1"
                        />
                    </div>
                </div>
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="max-w-full fixed left-0 shadow-4xl right-0 top-[3.5rem] p-5 pt-0 bg-white dark:bg-secondary-dark shadow-lg"
                    >
                        <nav className="flex flex-col gap-4 max-w-[350px] m-auto">
                            <motion.div
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{
                                    type: "spring",
                                    stiffness: 260,
                                    damping: 20,
                                    delay: 0.1,
                                }}
                                className="w-full"
                                onClick={() => setOpen(false)}
                            >
                                <NavButton scrollTo="aboutUsSection">
                                    about us
                                </NavButton>
                            </motion.div>
                            <motion.div
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{
                                    type: "spring",
                                    stiffness: 260,
                                    damping: 20,
                                    delay: 0.2,
                                }}
                                className="w-full"
                                onClick={() => setOpen(false)}
                            >
                                <NavButton scrollTo="reviewsSection">
                                    participate
                                </NavButton>
                            </motion.div>
                            <motion.div
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{
                                    type: "spring",
                                    stiffness: 260,
                                    damping: 20,
                                    delay: 0.3,
                                }}
                                className="w-full"
                                onClick={() => setOpen(false)}
                            >
                                <NavButton scrollTo="contactSection">
                                    contact
                                </NavButton>
                            </motion.div>
                        </nav>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default MobileGuestHeader;
